export interface Step {
  index: string;
  title: string;
  text: string;
}

export interface Rule {
  id: string;
  title: string;
  text: string;
}

export const PARTICIPATION_STEPS: Step[] = [
  {
    index: '01',
    title: '注册并报名',
    text: '用手机号或邮箱完成注册，填写基本信息并选择所属赛区，报名与海选征集同步开启。',
  },
  {
    index: '02',
    title: '提交作品',
    text: '上传你的爆料线索或内容作品，最多 3 份，每份都需要附上信息来源说明与时间线。',
  },
  {
    index: '03',
    title: '等待资格初审',
    text: '组委会核验原创性与合规性，材料缺失会通过站内信通知补正，补正窗口 48 小时。',
  },
  {
    index: '04',
    title: '进入公投并跟紧日程',
    text: '通过初审后进入初赛公开投票，订阅赛程提醒，按时间表参与初赛、复赛与决赛。',
  },
];

export const RULES: Rule[] = [
  { id: 'r1', title: '原创为先', text: '作品必须为原创，禁止搬运、抄袭或拼接他人内容，经核实立即取消参赛资格。' },
  { id: 'r2', title: '禁止刷票', text: '不得通过任何技术手段刷票，系统监测到异常增长将清零票数并公示处理结果。' },
  { id: 'r3', title: '信息来源说明', text: '提交材料需包含可核验的信息来源，无法核实的线索不计入评分，也不进入公投。' },
  { id: 'r4', title: '隐私与合规', text: '涉及个人隐私或未经证实的指控需做打码处理，违反合规要求的内容不予通过初审。' },
  { id: 'r5', title: '实名申诉', text: '结果公示期内可提交实名申诉与证据材料，逾期或匿名提交的申诉不予受理。' },
  { id: 'r6', title: '团队限制', text: '团队参赛人数不超过 5 人，奖项与奖金以主创账号名义发放，内部自行协商分配。' },
];